import { Component, HostListener, Inject, OnInit } from "@angular/core";
import {
	MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
	MatLegacyDialogRef as MatDialogRef,
} from "@angular/material/legacy-dialog";

@Component({
	selector: "tg-confirm-dialog",
	templateUrl: "./confirm-save-dialog.component.html",
	styleUrls: ["./confirm-save-dialog.component.scss"],
})
export class ConfirmSaveDialogComponent implements OnInit {
	constructor(
		@Inject(MAT_DIALOG_DATA) private data: { text: string; strings?: { [key: string]: string } },
		private ref: MatDialogRef<ConfirmSaveDialogComponent>
	) {}

	ngOnInit(): void {}
	@HostListener("document:keydown.escape")
	onEscape() {
		this.ref.close("stay");
	}
	get message() {
		return this.data.text;
	}
	get strings() {
		"";
		return this.data.strings || {};
	}

	stay() {
		this.ref.close("stay");
	}

	discard() {
		this.ref.close("leave");
	}

	saveAndLeave() {
		this.ref.close("saveAndLeave");
	}
}
